import React, { useContext, useLayoutEffect } from 'react';

import type { Direction, SliderHandles } from '@swf/components/Slider/Slider';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import Translation from '@swf/components/Translation/Translation';
import { Size } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';

import Banner from '../Modal/Banner/Banner';
import Header from '../Modal/Header/Header';

import { TXTMOB_Cash_Game, TXTMOB_Create } from './CreateCashGame.messages.json';
import styles from './CreateCashGame.scss';
import Container from './CreateGameForm/Container';

interface Title {
  newLine?: boolean;
}

const BannerTitle: React.FC<Title> = ({ newLine = false }) => (
  <>
    <Translation {...TXTMOB_Create} />
    {newLine ? <br /> : ' '}
    <Translation {...TXTMOB_Cash_Game} />
  </>
);

const CreateCashGame = () => {
  const { setStyle } = useContext(ModalContext);
  const sliderRef = React.createRef<SliderHandles>();
  const onDirection = (direction: Direction) => {
    sliderRef.current?.scroll(direction);
  };
  const { greaterThan } = useScreenSize();
  const showBanner = greaterThan(Size.Small);

  useLayoutEffect(() => {
    setStyle({ className: styles.createGameModal, closeOnOverlayClick: true, closeOnEsc: true });
  });

  return (
    <div className={styles.inner}>
      {showBanner && (
        <Banner
          title={<BannerTitle newLine />}
          onDirection={onDirection}
          className={styles.bannerBg}
        />
      )}
      <div className={styles.content}>
        <Header title={!showBanner && <BannerTitle />} />
        <Body className={styles.body}>
          <Container />
        </Body>
      </div>
    </div>
  );
};

export default CreateCashGame;
